<template>
  <div>
    <ts-loading-banner :loading="loadingPreData">
      <div class="d-flex justify-content-between">
        <legend class="text-black">
          {{ $t('studentScoringEntry.scoreRating') }}
        </legend>
        <ts-input
          v-model="search"
          :placeholder="$t('search')"
          style="width: 300px"
        />
      </div>
      <div class="overflow-auto" style="height: 62vh">
        <table class="table table-bordered">
          <thead>
            <tr class="ts-sticky ts-top-0 ts-bg-gray-200">
              <th class="text-center" rowspan="2">
                Learning Expectation
              </th>
              <th
                class="ts-text-xs text-center"
                v-for="(grading, index) in gradingDefiniton"
                :key="index"
              >
                <span class="badge bg-info rounded-pill">{{
                  grading.grade
                }}</span>
                <br />
                {{ grading.definition_name_en }} / {{ grading.definition_name_kh  }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(records, index) in resources">
              <tr style="background-color: #F9FBFB">
                <td
                  style="padding: 11px 4px"
                  :colspan="gradingDefiniton.length + 1"
                  class="text-primary ts-font-bold"
                >
                  {{ records[0].core_subject_name_foreign }}
                </td>
              </tr>
              <tr v-for="(item, index) in records">
                <td>
                  <span class="ts-text-xs">{{
                    item.elective_subject_name_foreign
                  }}</span>
                </td>
                <td
                  v-for="(grading, indexColumn) in gradingDefiniton"
                  :key="indexColumn"
                  class="text-center"
                >
                  <input
                    :id="index + '_grade_' + indexColumn"
                    type="radio"
                    v-model="item.grade"
                    :value="grading.grade"
                    :checked="item.grade === grading.grade ? true : false"
                    class="ts-cursor-pointer ts-text-lg"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'learning-expectation-rating',
  props: ['value', 'modelData', 'learningExepectationSubjects', 'validate'],
  data() {
    return {
      datatable: [],
      waiting: false,
      loading: false,
      show_alert: false,
      errors: new Errors(),
      gradingDefiniton: [],
      loadingPreData: false,
      model: {},
      search: ''
    }
  },
  computed: {
    resources() {
      return this.groupBy(
        this.datatable.filter(
          el =>
            el.core_subject_name_foreign
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            el.elective_subject_name_foreign
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1
        ),
        'subject_id'
      )
    }
  },
  created() {
    this.fetchData()
    this.model = this.modelData
  },
  methods: {
    async fetchData() {
      this.loading = true
      await this.getGradingDefiniton()
        .then(response => {
          this.gradingDefiniton = response.data.filter(el => el.acps_id == this.model.acps_id)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    pushToDatatable() {
      this.datatable = []
      this.learningExepectationSubjects.forEach(data => {
        let row = this.value.find(el => el.sc_subject_id == data.sc_subject_id)
        let detail = Object.assign({}, this.newItem, data, {
          scoring_id: row ? row.scoring_id : 0,
          subject_id: row ? row.subject_id : data.subject_id,
          core_subject_name_foreign: row ? row.core_subject_name_foreign : data.core_subject_name_foreign,
          sc_subject_id: row ? row.sc_subject_id : data.sc_subject_id,
          elective_subject_name_foreign: row ? row.elective_subject_name_foreign : data.elective_subject_name_foreign,
          grade: row ? row.grade : ''
        })
        this.$nextTick(() => {
          this.datatable.push(detail)
        })
      })
    },
    getGradingDefiniton() {
      return this.$store.dispatch('gradingDefinition/fetch', {
        fields: {
          score_grading_definitions: 'grade,definition_name_en,definition_name_kh,acps_id,definition_type'
        },
        filter: {
          acp_id: this.model.acp_id,
          acps_id: this.model.acps_id,
          definition_type: 'Rating'
        },
        page: -1
      })
    },
    groupBy(array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    }
  },
  watch: {
    value: {
      handler(val) {
        if (_.isEqual(val, this.datatable)) return

        this.pushToDatatable()
      },
      deep: true,
      immediate: true
    },

    datatable: {
      handler(val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    },
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
label {
  display: block;
  margin-bottom: 0;
}

input[type='radio'] {
  appearance: none;
  background-color: #fff;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 2px;
  display: inline-grid;
  place-content: center;
}

input[type='radio']::before {
  content: '';
  width: 10px;
  height: 10px;
  transform: scale(0);
  transform-origin: bottom left;
  background-color: #fff;
  clip-path: polygon(13% 50%, 34% 66%, 81% 2%, 100% 18%, 39% 100%, 0 71%);
}

input[type='radio']:checked::before {
  transform: scale(1);
}
input[type='radio']:checked {
  background-color: #348fe2;
  border: 2px solid #348fe2;
}
</style>
